//Amplitude base script
(function (e, t) {
    var n = e.amplitude || { _q: [], _iq: {} }; var r = t.createElement("script")
        ; r.type = "text/javascript"; r.async = true
        ; r.src = "https://cdn.amplitude.com/libs/amplitude-4.5.2-min.gz.js"
        ; r.onload = function () {
            if (e.amplitude.runQueuedFunctions) {
                e.amplitude.runQueuedFunctions()
            } else {
                console.log("[Amplitude] Error: could not load SDK")
            }
        }
        ; var i = t.getElementsByTagName("script")[0]; i.parentNode.insertBefore(r, i)
        ; function s(e, t) {
            e.prototype[t] = function () {
                this._q.push([t].concat(Array.prototype.slice.call(arguments, 0))); return this
            }
        }
    var o = function () { this._q = []; return this }
        ; var a = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset"]
        ; for (var u = 0; u < a.length; u++) { s(o, a[u]) } n.Identify = o; var c = function () {
            this._q = []
                ; return this
        }
        ; var l = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"]
        ; for (var p = 0; p < l.length; p++) { s(c, l[p]) } n.Revenue = c
        ; var d = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut",
            "setVersionName", "setDomain", "setDeviceId", "setGlobalUserProperties", "identify",
            "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "logEventWithTimestamp",
            "logEventWithGroups", "setSessionId", "resetSessionId"]
        ; function v(e) {
            function t(t) {
                e[t] = function () {
                    e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)))
                }
            }
            for (var n = 0; n < d.length; n++) { t(d[n]) }
        } v(n); n.getInstance = function (e) {
            e = (!e || e.length === 0 ? "$default_instance" : e).toLowerCase()
                ; if (!n._iq.hasOwnProperty(e)) { n._iq[e] = { _q: [] }; v(n._iq[e]) } return n._iq[e]
        }
        ; e.amplitude = n;
})(window, document);

//Amplitude config & init
(function (app) {
    app.run(['amplitudeService', 'featureToggleService', function (amplitudeService, featureToggleService) {
        var myAmplitude = amplitude.getInstance();
        var environment = featureToggleService.checkEnv() || 'Undefined Environment';

        //Warning: Clears all custom user properties (does not affect Amplitude default properties). Irreversible
        function clearUserProperties() {
            myAmplitude.clearUserProperties();
        }

        //Initialize Amplitude. Then add FigAuth ID & user properties to Amplitude.
        if (environment === 'prod') {
            myAmplitude.init('45e8b609a44e2356fbb4366fa6840b76', amplitudeService.setupNavigation());
        } else {
            myAmplitude.init('d2e7f05450840dfbd217770fa3e94b47', amplitudeService.setupNavigation());
        }
    }
    ]);
})(window.app);

//To use service in controller, inject then call a similar function below:
//          $ctrl.logAmplitude = function (eventName, [propertyName]) {
//             return amplitudeService.logEvent(eventName, [propertyName]);
//          };
//
//            propertyName can can be click target object names for 'Click' events. Is ommitted for 'Navigation' events since we log state information for those instead.


//Reference URL:
//https://amplitude.zendesk.com/hc/en-us/articles/115002889587-JavaScript-SDK-Reference